/**
 * EIKO Premium — shared behaviors for the Premium design system.
 * Scroll reveal for elements marked class="eiko-reveal".
 */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.eiko-reveal').forEach(function (el) {
      el.classList.add('eiko-reveal--visible');
    });
  }

  if (reduceMotion || typeof IntersectionObserver === 'undefined') {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('eiko-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  function observeAll() {
    document.querySelectorAll('.eiko-reveal:not(.eiko-reveal--visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  document.addEventListener('shopify:section:load', observeAll);
})();
